import WineLoversService from 'services/wineLoversService';
import { adaptWineLoversCountriesFilter, adaptWineLoversStatesFilter } from 'helpers/adapter';
import {
  channelOptions,
  roleOptions,
  interestOptions,
  registrationTypeOptions,
  receiveMarketingEmailsOptionsForWineLovers,
  receiveNewsEmailsOptionsForWineLovers,
  receiveEventsEmailsOptionsForWineLovers,
} from 'constants/winlover-filters';
import UserName from '../commonCellComponent/userName/UserName';

const tableOptions = {
  wineLover: {
    fields: [
      {
        id: 'name',
        label: 'table.wineLover.user',
        component: UserName,
        type: 'customComponent',
        sortable: true,
        width: '15%',
        cellPaddingLeft: '24px',
      },
      {
        id: 'id',
        label: 'table.wineLoversActivities.id',
        type: 'text',
        sortable: true,
        width: '7%',
      },
      {
        id: 'userType',
        label: 'table.wineLover.userType',
        type: 'text',
        sortable: true,
        width: '10%',
      },
      {
        id: 'provider',
        label: 'table.wineLover.provider',
        type: 'text',
        sortable: true,
        width: '6%',
      },
      {
        id: 'country',
        label: 'table.wineLover.country',
        type: 'text',
        sortable: true,
        width: '6%',
      },
      {
        id: 'state',
        label: 'table.wineLover.state',
        type: 'text',
        sortable: true,
        width: '6%',
      },
      {
        id: 'registrationType',
        label: 'table.wineLover.registrationType',
        type: 'text',
        sortable: true,
        width: '7%',
      },
      {
        id: 'interests',
        label: 'table.wineLover.interests',
        type: 'text',
        sortable: true,
        width: '10%',
      },
      {
        id: 'receiveMarketingEmails',
        label: 'table.wineLover.receiveMarketingEmails',
        type: 'text',
        sortable: true,
        width: '5%',
      },
      {
        id: 'receiveNewsEmails',
        label: 'table.wineLover.receiveNewsEmails',
        type: 'text',
        sortable: true,
        width: '5%',
      },
      {
        id: 'receiveEventsEmails',
        label: 'table.wineLover.receiveEventsEmails',
        type: 'text',
        sortable: true,
        width: '5%',
      },
      {
        id: 'createdAt',
        label: 'table.wineLover.registrationDate',
        type: 'text',
        sortable: true,
        width: '9%',
        textAlign: 'right',
        headAlign: 'right',
      },
      {
        id: 'lastLogin',
        label: 'table.wineLover.lastLoginDate',
        type: 'text',
        sortable: true,
        width: '9%',
        textAlign: 'right',
        headAlign: 'right',
      },
    ],
    rowsPerPageOptions: [5, 10, 25, 50, 100],
    filterFields: [
      {
        id: 'userType_in',
        label: 'table.wineLoversActivities.filter.role.title',
        type: 'custom-multi-autocomplete',
        options: roleOptions,
        withoutParams: true,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'provider_in',
        label: 'table.wineLover.filter.channel.title',
        type: 'custom-multi-autocomplete',
        options: channelOptions,
        withoutParams: true,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'country_in',
        label: 'table.wineLover.filter.country',
        type: 'custom-multi-autocomplete',
        options: WineLoversService.getWineLoversCountriesFilter,
        adapterCallback: adaptWineLoversCountriesFilter,
        optionsType: 'string',
        withoutParams: true,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'state_in',
        label: 'table.wineLover.filter.state',
        type: 'custom-multi-autocomplete',
        options: WineLoversService.getWineLoversStatesFilter,
        adapterCallback: adaptWineLoversStatesFilter,
        optionsType: 'string',
        withoutParams: true,
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'registrationType_in',
        label: 'table.wineLoversActivities.filter.registrationType.title',
        type: 'custom-multi-autocomplete',
        options: registrationTypeOptions,
        withoutParams: true,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'interests_like',
        label: 'table.wineLoversActivities.filter.interests.title',
        type: 'custom-multi-autocomplete',
        options: interestOptions,
        withoutParams: true,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'receiveMarketingEmails_eq',
        label: 'table.wineLoversActivities.filter.receiveMarketingEmails.title',
        type: 'select',
        options: receiveMarketingEmailsOptionsForWineLovers,
        priority: 1,
        optionsWithCheckbox: false,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'receiveNewsEmails_eq',
        label: 'table.wineLoversActivities.filter.receiveNewsEmails.title',
        type: 'select',
        options: receiveNewsEmailsOptionsForWineLovers,
        priority: 1,
        optionsWithCheckbox: false,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'receiveEventsEmails_eq',
        label: 'table.wineLoversActivities.filter.receiveEventsEmails.title',
        type: 'select',
        options: receiveEventsEmailsOptionsForWineLovers,
        priority: 1,
        optionsWithCheckbox: false,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'createdAt',
        label: 'table.wineLover.filter.registrationDate',
        type: 'dateRange',
        priority: 1,
        selectedClassName: 'colorizeSelected',
      },
      {
        id: 'lastLogin',
        label: 'table.wineLover.filter.lastLogin',
        type: 'dateRange',
        priority: 1,
        selectedClassName: 'colorizeSelected',
      },
    ],
    searchFields: ['name', 'email'],
  },
};

export default tableOptions;
